// Generouted, changes to this file will be overridden
/* eslint-disable */

import { components, hooks, utils } from '@generouted/react-router/client'

export type Path =
  | `/`
  | `/dashboard`
  | `/dashboard/announcements`
  | `/dashboard/contact`
  | `/dashboard/contact/:contactPId`
  | `/dashboard/contact/:contactPId/:transactionPId/files`
  | `/dashboard/contact/:contactPId/:transactionPId/files/document/:documentId`
  | `/dashboard/contact/:contactPId/:transactionPId/files/formSubmission/:formSubmissionId`
  | `/dashboard/faqs`
  | `/dashboard/faqs/:faqPId`
  | `/dashboard/reports`
  | `/dashboard/reports/sales-ranking`
  | `/dashboard/schedule`
  | `/dashboard/schedule/print/:from/:monthCount`
  | `/dashboard/settings`
  | `/dashboard/settings/staff`
  | `/dashboard/settings/staff/:userId`
  | `/dashboard/settings/staff/scheduling`
  | `/dashboard/transaction/:pId`
  | `/dashboard/transaction/:pId/agility-compliance/:userId`
  | `/dashboard/transaction/:pId/agility-credit-report/:userId/:agilityPId`
  | `/dashboard/transaction/:pId/co-buyer`
  | `/dashboard/transaction/:pId/co-buyer/add`
  | `/dashboard/transaction/:pId/customer/:userId`
  | `/dashboard/transaction/:pId/deal-jacket`
  | `/dashboard/transaction/:pId/deal-jacket/document/:documentId`
  | `/dashboard/transaction/:pId/deal-jacket/formSubmission/:formSubmissionId`
  | `/dashboard/transaction/:pId/deal-jacket/view`
  | `/dashboard/transaction/:pId/idv/:verifId`
  | `/dashboard/transaction/:pId/lending-portal/buyer`
  | `/dashboard/transaction/:pId/lending-portal/co-buyer`
  | `/dashboard/transaction/:pId/lending-portal/vehicles`
  | `/dashboard/transaction/:pId/prequal-report/:userId/:reportId`
  | `/dashboard/transaction/:pId/prescreen-report/:userId/:reportId`
  | `/dashboard/transaction/:pId/vehicle/purchase`
  | `/dashboard/transaction/:pId/vehicle/purchase/recall-masters/:recallReportId`
  | `/dashboard/transaction/:pId/vehicle/standby/:extractionId`
  | `/dashboard/transaction/:pId/vehicle/trade`
  | `/dashboard/transaction/:pId/vehicle/trade-upload`
  | `/ip-blocked`
  | `/profile`
  | `/suspended`

export type Params = {
  '/dashboard/contact/:contactPId': { contactPId: string }
  '/dashboard/contact/:contactPId/:transactionPId/files': { contactPId: string; transactionPId: string }
  '/dashboard/contact/:contactPId/:transactionPId/files/document/:documentId': { contactPId: string; transactionPId: string; documentId: string }
  '/dashboard/contact/:contactPId/:transactionPId/files/formSubmission/:formSubmissionId': { contactPId: string; transactionPId: string; formSubmissionId: string }
  '/dashboard/faqs/:faqPId': { faqPId: string }
  '/dashboard/schedule/print/:from/:monthCount': { from: string; monthCount: string }
  '/dashboard/settings/staff/:userId': { userId: string }
  '/dashboard/transaction/:pId': { pId: string }
  '/dashboard/transaction/:pId/agility-compliance/:userId': { pId: string; userId: string }
  '/dashboard/transaction/:pId/agility-credit-report/:userId/:agilityPId': { pId: string; userId: string; agilityPId: string }
  '/dashboard/transaction/:pId/co-buyer': { pId: string }
  '/dashboard/transaction/:pId/co-buyer/add': { pId: string }
  '/dashboard/transaction/:pId/customer/:userId': { pId: string; userId: string }
  '/dashboard/transaction/:pId/deal-jacket': { pId: string }
  '/dashboard/transaction/:pId/deal-jacket/document/:documentId': { pId: string; documentId: string }
  '/dashboard/transaction/:pId/deal-jacket/formSubmission/:formSubmissionId': { pId: string; formSubmissionId: string }
  '/dashboard/transaction/:pId/deal-jacket/view': { pId: string }
  '/dashboard/transaction/:pId/idv/:verifId': { pId: string; verifId: string }
  '/dashboard/transaction/:pId/lending-portal/buyer': { pId: string }
  '/dashboard/transaction/:pId/lending-portal/co-buyer': { pId: string }
  '/dashboard/transaction/:pId/lending-portal/vehicles': { pId: string }
  '/dashboard/transaction/:pId/prequal-report/:userId/:reportId': { pId: string; userId: string; reportId: string }
  '/dashboard/transaction/:pId/prescreen-report/:userId/:reportId': { pId: string; userId: string; reportId: string }
  '/dashboard/transaction/:pId/vehicle/purchase': { pId: string }
  '/dashboard/transaction/:pId/vehicle/purchase/recall-masters/:recallReportId': { pId: string; recallReportId: string }
  '/dashboard/transaction/:pId/vehicle/standby/:extractionId': { pId: string; extractionId: string }
  '/dashboard/transaction/:pId/vehicle/trade': { pId: string }
  '/dashboard/transaction/:pId/vehicle/trade-upload': { pId: string }
}

export type ModalPath = `/dashboard/settings/staff/create` | `/dashboard/transaction/[pId]/customer/[userId]/id` | `/dashboard/transaction/[pId]/dealScenarios` | `/dashboard/transaction/create`

export const { Link, Navigate } = components<Path, Params>()
export const { useModals, useNavigate, useParams } = hooks<Path, Params, ModalPath>()
export const { redirect } = utils<Path, Params>()
